import { useQueryClient } from '@tanstack/react-query';
export function queryUserFromCompanies(queryClient, userId) {
    const companies = queryClient.getQueryData([
        'admin',
        'companies',
    ]);
    const companyIds = companies?.map((company) => company.id) || [];
    for (const companyId of companyIds) {
        const usersResponse = queryClient.getQueryData([
            'admin',
            'companies',
            `${companyId}`,
            'users',
        ]);
        const user = usersResponse?.users?.find((user) => user.id === userId);
        if (user) {
            return user;
        }
    }
}
export function useQueryUserFromCompanies(userId) {
    const queryClient = useQueryClient();
    return queryUserFromCompanies(queryClient, userId);
}
//# sourceMappingURL=use-query-user-from-company.js.map